import ApiService from "../../../../ApiService";

const EditService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/agent/userbankaccount/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    saveBankCard: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/agent/userbankaccount/save", vo, successCallback, failureCallback);
    }
};

export default EditService;